import * as React from 'react';
import { Grid } from 'semantic-ui-react';


var ModalItem = function (_a) {
    var type = _a.type, value = _a.value, _b = _a.divider, divider = _b === void 0 ? true : _b;
    return (React.createElement(Grid.Row, { className: 'ModalItem' },
        React.createElement(Grid.Column, { textAlign: 'left' },
            React.createElement("div", { className: 'value-description' }, type)),
        React.createElement(Grid.Column, { textAlign: 'right' },
            React.createElement("div", { className: 'value ellipsis' }, value)),
        divider && React.createElement("div", { className: 'divider' })));
};
export default React.memo(ModalItem);
